<template>
  <g
    id="Grupo_136"
    data-name="Grupo 136"
    transform="rotate(180 372.928 116.28)"
  >
    <g
      id="Grupo_136-2"
      data-name="Grupo 136"
      transform="translate(712.388 199)"
    >
      <path
        id="Trazado_3536"
        data-name="Trazado 3536"
        class="cls-1"
        d="M1397.91 543c0 1.562.02 3.124 0 4.685a11.367 11.367 0 0 0 2.18 6.9 8.985 8.985 0 0 1 1.625 3.816 8.829 8.829 0 0 1-17.235 3.751 8.483 8.483 0 0 1 1.379-7.433 11.271 11.271 0 0 0 2.246-7c-.018-1.572 0-3.145 0-4.718zm-7.867 6.039c-.074.506-.129.981-.216 1.451a12.867 12.867 0 0 1-2.4 5.39 6.427 6.427 0 0 0-1.2 5.082 6.767 6.767 0 0 0 7.57 5.71 6.853 6.853 0 0 0 4.723-10.9 13.524 13.524 0 0 1-2.34-5.353c-.088-.457-.146-.919-.218-1.384zm.024-2h5.858v-2.046h-5.858z"
        transform="translate(-1376.282 -543)"
      />
      <rect
        id="Rectángulo_31"
        data-name="Rectángulo 31"
        class="cls-1"
        width="3.902"
        height="1.966"
        rx=".983"
        transform="translate(29.567 15.797)"
      />
      <rect
        id="Rectángulo_32"
        data-name="Rectángulo 32"
        class="cls-1"
        width="1.963"
        height="3.91"
        rx=".981"
        transform="translate(15.74 29.651)"
      />
      <path
        id="Trazado_3537"
        data-name="Trazado 3537"
        class="cls-1"
        d="m1337.424 934.436.013.013a.91.91 0 0 1 0 1.285l-1.419 1.421a.909.909 0 0 1-1.287 0l-.018-.018a.91.91 0 0 1 0-1.288l1.424-1.416a.91.91 0 0 1 1.287.003z"
        transform="translate(-1329.827 -908.528)"
      />
      <path
        id="Trazado_3538"
        data-name="Trazado 3538"
        class="cls-1"
        d="m1654.105 934.569 1.371 1.373a.922.922 0 0 1 0 1.3l-.014.015a.922.922 0 0 1-1.306 0l-1.37-1.374a.922.922 0 0 1 0-1.3l.013-.013a.922.922 0 0 1 1.306-.001z"
        transform="translate(-1627.049 -908.65)"
      />
      <rect
        id="Rectángulo_33"
        data-name="Rectángulo 33"
        class="cls-1"
        width="3.884"
        height="1.926"
        rx=".963"
        transform="translate(0 15.82)"
      />
    </g>
  </g>
</template>
